// extracted by mini-css-extract-plugin
module.exports = {"TextColor":"TextColor_TextColor__1JsUH","Selected":"TextColor_Selected__Y36y7"};